import * as debug from './debug.service';
import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class NotificationService {

	constructor(
		public snackBar: MatSnackBar,
		private readonly zone: NgZone) {
		debug.log('007 NotificationService instantiated');
	}

	showSuccess(message: string): void {
		if (!!!message) {
			return;
		}

		// Had an issue with the snackbar being ran outside of angular's zone.
		this.zone.run(() => {
			this.snackBar.open(message);
		});
	}

	showError(message: string): void {
		if (!!!message) {
			return;
		}

		this.zone.run(() => {
			// The second parameter is the text in the button.
			// In the third, we send in the css class for the snack bar.
			this.snackBar.open(message, 'X', { panelClass: ['error', 'snack-bar-container-overflow-fix'] });
		});
	}

	showWarning(message: string): void {
		if (!!!message) {
			return;
		}

		this.zone.run(() => {
			// The second parameter is the text in the button.
			// In the third, we send in the css class for the snack bar.
			this.snackBar.open(message, 'X', { panelClass: ['warn', 'snack-bar-container-overflow-fix'] });
		});
	}
}
